import { Box, Card } from '@mui/material';
import CustomFilterButton from 'components/Fileds/CustomFilterButton';
import { manageAccountRoles } from 'utils/constant';
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated';
import NoSearchFound from 'components/NoSearchFound/NoSearchFound';
import CommonDataGrid from 'components/TableListing/CommonTable';
import HeaderTilteBar from 'components/TitleBar/HeaderTilteBar';
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import { getOrderTypePermissions, isPermissionAllowed } from 'utils/function';
import MainContainer from 'theme/MainConatiner';

const ManageAccountsContainer = ({
    columns,
    rows,
    totalCount,
    loading,
    searchQuery,
    setSearchQuery,
    paginationModel,
    setPaginationModel,
    error,
    handleAddBtn,
    handleEdit,
    handleDelete,
    selectedRole,
    setSelectedRole,
}) => {
    const isSearching = searchQuery.trim().length > 0;
    const hasData = !loading && rows.length > 0;
    const showNoItems = !loading && rows.length === 0;

    const posData = useSelector((state) => state?.posData);
    const permissions = useMemo(() => getOrderTypePermissions(posData), [posData]);
    const isEmenuAllowed = isPermissionAllowed(permissions, 'permission_pos_e_menu');

    const roleFilters = useMemo(() => {
        const roles = manageAccountRoles.filter(r => r.value !== 'emenu' || isEmenuAllowed);
        return [{ value: 'all', label: 'All' }, ...roles];
    }, [isEmenuAllowed]);

    return (
        <MainContainer>
            <Card className="main-card-container" sx={{ padding: '0px !important' }}>
                <HeaderTilteBar
                    title="Manage Accounts"
                    isSearch={rows?.length > 0 || isSearching}
                    btnText="Add New"
                    btnIcon={true}
                    onSearchChange={setSearchQuery}
                    searchQuery={searchQuery}
                    handleAddBtn={handleAddBtn}
                    // padding={"16px 10px 8px 10px"}
                >
                    <Box sx={{ display: 'flex', gap: '15px', ml: 3 }}>
                        {roleFilters.map((f) => (
                            <CustomFilterButton
                                key={f.value}
                                label={f.label}
                                color="#000000"
                                backgroundColor="#000000"
                                selected={selectedRole === f.value}
                                onClick={() => setSelectedRole(f.value)}
                                height={"33px"}
                            />
                        ))}
                    </Box>
                </HeaderTilteBar>

                {showNoItems ? (
                    <Box className="body-wrapper">
                        {isSearching ? (
                            <NoSearchFound
                                title="No accounts match your search"
                                subtitle="Please try again with a different keyword."
                            />
                        ) : (
                            <NoItemsCreated
                                title="No Staff Account Created Yet!"
                                subtitle="Add your first staff account."
                            />
                        )}
                    </Box>
                ) : (
                    <Box>
                        <CommonDataGrid
                            columns={columns}
                            rows={rows}
                            rowCount={totalCount}
                            loading={loading}
                            paginationModel={paginationModel}
                            setPaginationModel={setPaginationModel}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                        />
                    </Box>
                )}
            </Card>
        </MainContainer>
    )
}

export default ManageAccountsContainer
